<template>
  <el-dialog
    title="Delete Recurring Shift"
    :visible.sync="isVisible"
    width="480px"
    :close-on-click-modal="false"
  >
    <p>This is a recurring shift. How would you like to delete it?</p>
    <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 8px;">
      <el-button
        style="text-align: left; height: auto; white-space: normal; padding: 10px 16px;"
        @click="$emit('this-only')"
      >
        <strong>This shift only</strong><br>
        <span style="font-size: 0.85em; color: #606266;">Remove only this occurrence. Past and future shifts remain.</span>
      </el-button>
      <el-button
        style="text-align: left; height: auto; white-space: normal; padding: 10px 16px;"
        @click="$emit('this-and-future')"
      >
        <strong>This and future shifts</strong><br>
        <span style="font-size: 0.85em; color: #606266;">Remove this occurrence and all upcoming ones. Past shifts remain.</span>
      </el-button>
      <el-button
        type="danger"
        style="text-align: left; height: auto; white-space: normal; padding: 10px 16px;"
        @click="$emit('all-shifts')"
      >
        <strong>All shifts in series</strong><br>
        <span style="font-size: 0.85em; color: #606266;">Remove every occurrence — past, present, and future.</span>
      </el-button>
    </div>
    <span slot="footer">
      <el-button @click="isVisible = false">Cancel</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "DeleteRecurringShiftDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
};
</script>
